import { createContext, useState } from 'react';

type valueShape = {
	currentTheme: string;
	setCurrentTheme: (theme: string) => void;
};

export const ThemeContext = createContext<any>(null);

export const ThemeContextProvider = ({ children }: { children: any }) => {
	//States
	const [currentTheme, setCurrentTheme] = useState<string>('dark');

	const value: valueShape = {
		currentTheme,
		setCurrentTheme,
	};

	return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};
